import React from "react";
import { useMediaQuery } from "@mui/material";
import OpenAccountWebView from "./OpenAccountWebView";
import OpenAccountMobileView from "./OpenAccountMobileView";

const OpenAccount = () => {
  const isSmallScreen = useMediaQuery("(max-width:700px)");

  return isSmallScreen ? <OpenAccountMobileView /> : <OpenAccountWebView />;
};

export default OpenAccount;
